import * as React from "react";
import { Drawer } from "@grandvisionhq/common";
const FacetsDrawer = ({
  title,
  ctaButton,
  clearFacetsButton,
  children,
  footerButton,
  onClose
}) => {
  return /* @__PURE__ */ React.createElement(Drawer, { direction: "bottom", onClose }, ctaButton, /* @__PURE__ */ React.createElement(Drawer.Portal, null, /* @__PURE__ */ React.createElement(Drawer.Backdrop, null), /* @__PURE__ */ React.createElement(Drawer.Overlay, { shouldMountContent: true, disableInitialFocus: true }, /* @__PURE__ */ React.createElement(
    Drawer.Header,
    {
      LeftSlot: /* @__PURE__ */ React.createElement(Drawer.Title, null, title),
      RightSlot: clearFacetsButton,
      hasBottomBorder: true
    }
  ), /* @__PURE__ */ React.createElement(Drawer.Content, { isContained: false }, children), footerButton)));
};
export {
  FacetsDrawer
};
//# sourceMappingURL=FacetsDrawer.js.map
